import React, { Component } from "react";
import styles from "./winterMaintenceMapWrapper.module.scss";
import { withWinterMaintence } from "../../../shared/containers/containerWinterMaintence";
import { states } from "../../../reducers/queriesStates";
import { ColorPicker } from "material-ui-color";
import WinterMaintenceSensorTools from "./WinterMaintenceSensorTools";

class WinterMaintenceSensorsTools extends Component {
  render() {
    const { winterGroups, winterSensorsFilter, onSetWinterSensorssFilter, winterDashboard, winterCompaniesRoutesDataState } = this.props;

    if (winterGroups.length === 0) {
      return null;
    }

    const getCountInRoute = (data) => {
      return { ...data, distance: `${Math.round((data.distance + Number.EPSILON) * 100) / 100} км.` };
    };

    const sensorRouteViseble = winterCompaniesRoutesDataState !== states.NOT_REQUESTED;

    return (
      <div>
        <b>Оборудование:</b>

        <WinterMaintenceSensorTools
          sensorData={getCountInRoute(winterDashboard.sensors.dump)}
          filterBySenorKey={"filterDump1"}
          routeSensorKey={"viewRouteDump"}
          totalCount={winterDashboard.sensors.dump.totalCount}
          title={"Датчика отвала"}
          routeSensorTitle={"Маршрут датчиков отвала"}
          sensorColorKey={"dumpColor"}
          sensorRouteViseble={sensorRouteViseble}
        />

        <WinterMaintenceSensorTools
          sensorData={getCountInRoute(winterDashboard.sensors.sand)}
          filterBySenorKey={"filterSand"}
          routeSensorKey={"viewRouteSand"}
          totalCount={winterDashboard.sensors.sand.totalCount}
          title={"Датчика посыпки "}
          routeSensorTitle={"Маршрут датчиков посыпки"}
          sensorColorKey={"sandColor"}
          sensorRouteViseble={sensorRouteViseble}
        />
      </div>
    );
  }
}

export default withWinterMaintence(React.memo(WinterMaintenceSensorsTools));
